import { graphql, useStaticQuery } from "gatsby";

const PackagesNoResultsQuery = () => {
	const { allContentfulCollection: data } = useStaticQuery(graphql`
		query PackagesNoResultsQuery {
			allContentfulCollection(filter: { contentful_id: { eq: "33guGYj2JSHq0FfDVNovPM" } }) {
				edges {
					node {
						node_locale
						variant
						cardsPerPage
						itemsPerRow
						cards {
							heading
							headingAs
							variant
							content {
								raw
							}
							image {
								secure_url
								width
								height
								raw_transformation
								version
								public_id
								format
							}
							link {
								url
								variant
								type
								linkText
								target
							}
						}
					}
				}
			}
		}
	`);
	return data.edges;
};

export default PackagesNoResultsQuery;
export { PackagesNoResultsQuery };
